import React, { useEffect } from "react";
import "./Blog_inner.css";
import Breadcrumb_comp from "../../Common-Component/Breadcrumb_comp/Breadcrumb_comp"
import Latest_Blog from "./Latest_Blog/Latest_Blog";
import Blog_inner_Banner from "./Blog_inner_Banner/Blog_inner_Banner";
import Blog_inner_content from "./Blog_inner_content/Blog_inner_content";
import Stay_Ahead from "./Stay_Ahead/Stay_Ahead";
import { getblogById } from "../../../features/blog/Slice";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

function Blog_inner() {

    const { id } = useParams();
    const blogid = useSelector((state) => state.blog.addBlogById);
    const dispatch = useDispatch();
  
    useEffect(() => {
      if (id) {
        dispatch(getblogById(id));
      }
    }, [dispatch, id]);


  const breadcrumbData = [
    { name: "Home", link: "/home" },
    { name: "Blog", link: "/blog" },
    { name: "HOW TO CHOOSE THE BEST STANDARD BUSINESS CARD FOR ..." },
  ];
  return (
    <section className="Blog_inner">
      <div className="custom_container">
      <div className="breadcrump_holder">
          <div className="Breadcrumb_div">
            <Breadcrumb_comp data={breadcrumbData} />
          </div>
        </div>
        <Blog_inner_Banner blogid={blogid}/>
        <Blog_inner_content blogid={blogid}/>
        <Latest_Blog />
        <Stay_Ahead />
      </div>
    </section>
  );
}

export default Blog_inner;
